import Http from '@/services/httpAcademy'

export const listEntitlements = (params) =>
	Http.get('/admin/entitlements', { params })

export const grantEntitlement = (data) =>
	Http.post('/admin/entitlements', data)

export const revokeEntitlement = ({ id, reason }) =>
	Http.patch(`/admin/entitlements/${id}/revoke`, { reason })
